import * as actions from './actionsTypes';

const initialState = {
  isLoadingEmployeesVacations: false,
  isLoadingEmployeeHalfDays: false,
  employeesVacations: {
    count: 0,
    data: []
  },
  employeesVacationsFail: null,
  employeeHalfDaysFail: null
}

export default function employeesVacationsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.IS_LOADING_EMPLOYEES_VACATIONS:
      return { ...state, isLoadingEmployeesVacations: action.payload };
    case actions.IS_LOADING_UPDATE_EMPLOYEE_HALF_DAYS:
      return { ...state, isLoadingEmployeeHalfDays: action.payload };
    case actions.GET_EMPLOYEES_VACATIONS:
      return { ...state, employeesVacations: action.payload };
    case actions.FAIL_EMPLOYEES_VACATIONS:
      return { ...state, employeesVacationsFail: action.payload };
    case actions.FAIL_UPDATE_EMPLOYEE_HALF_DAYS:
      return { ...state, employeeHalfDaysFail: action.payload };
    default:
      return state;
  }
}